<template>
  <div class="s-social">
    <div class="s-social__wrapper">
      <!-- regimen de salud -->
      <md-field>
        <label for="regsalud">Régimen de Salud</label>
        <md-select
          v-model="ldata.healthRegime"
          name="regsalud"
          id="regsalud"
          @md-selected="selectRegSalud"
          required
        >
          <md-option value="00">EsSalud Regular(Exclusivo)</md-option>
          <md-option value="01">EsSalud Regular Y EPS/Serv. Prop.</md-option>
          <md-option value="05">EsSalud Pensionistas</md-option>
          <md-option value="20">Sanidad FFAA y Policiales</md-option>
          <md-option value="21">SIS - Microempresa</md-option>
        </md-select>
      </md-field>

      <!-- prestadora de salud -->
      <md-field v-if="ldata.healthRegime == '01'">
        <label for="presalud">Prestadora de salud</label>
        <md-select v-model="ldata.eps" name="presalud" id="presalud" required>
          <md-option value="02">Pacífico</md-option>
          <md-option value="03">Rímac Internacional</md-option>
          <md-option value="04">Servicios propios</md-option>
          <md-option value="05">Mapfre Perú</md-option>
          <md-option value="06">Sanitas Perú</md-option>
          <md-option value="07">La Positiva</md-option>
        </md-select>
      </md-field>

      <!-- regimen Pensionario -->
      <md-field>
        <label for="regPens">Régimen Pensionario</label>
        <md-select
          v-model="ldata.pensionSystem"
          name="regpens"
          id="regpens"
          @md-selected="selectRegPen"
          required
        >
          <md-option value="02">ONP Sistema Nacional de Pensiones</md-option>
          <md-option value="21">SPP Integra</md-option>
          <!-- <md-option value="22">SPP Horizonte</md-option> -->
          <md-option value="23">SPP ProFuturo</md-option>
          <md-option value="24">SPP Prima</md-option>
          <md-option value="25">SPP Habitat</md-option>
          <md-option value="-1">SIN SIST. DE PENSION</md-option>
        </md-select>
      </md-field>
      <div
        class="field-radio"
        v-if="['21', '23', '24', '25'].includes(ldata.pensionSystem)"
      >
        <!-- <div class="field-radio__label">Gratificación</div> -->
        <md-checkbox v-model="ldata.disableSpp"
          >Desabilitar Prima de seguros</md-checkbox
        >
      </div>
      <!-- codigo cuspp -->
      <md-field
        v-if="
          ldata.pensionSystem &&
            ldata.pensionSystem != '02' &&
            ldata.pensionSystem != '-1'
        "
        :class="getValidationClass($v.ldata.cuspCode)"
      >
        <label>Código CUSPP</label>
        <md-input
          name="cuspCode"
          id="cuspCode"
          v-model="ldata.cuspCode"
        ></md-input>
        <span class="md-error" v-if="!$v.ldata.cuspCode.alphaNum"
          >Código ingresado no válido</span
        >
      </md-field>

      <!-- tipo d comision -->
      <md-field
        v-if="
          ldata.pensionSystem &&
            ldata.pensionSystem != '02' &&
            ldata.pensionSystem != '-1'
        "
      >
        <label for="comType">Tipo de comisión</label>
        <md-select
          v-model="ldata.pensionSystemType"
          name="comtype"
          id="comtype"
          required
        >
          <md-option value="01">Flujo</md-option>
          <md-option value="02">Mixta/Flujo</md-option>
          <!-- <md-option value="03">Mixta/Saldo</md-option> -->
        </md-select>
      </md-field>
    </div>
    <div
      v-show="ldata.state != 'registered'"
      class="s-social__sgte"
      @click="next()"
    >
      Siguiente
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { alphaNum } from "vuelidate/lib/validators";

export default {
  props: {
    value: Object,
    isHistoric: Boolean,
    historicId: String,
  },

  created() {
    console.log(this.value.id);
    if (this.value.id) this.ldata = this.value;
  },

  data() {
    return {
      ldata: {},
      healthRegime: null,
      pensionSystem: null,
      cuspCode: null,
      entSalud: null,
    };
  },

  validations: {
    // cuspCode: { alphaNum }
    ldata: {
      cuspCode: { alphaNum },
    },
  },

  watch: {
    value(newValue, oldValue) {
      this.ldata = newValue;
    },
  },

  methods: {
    ...mapActions({
      updateTRegister: "updateTRegister",
    }),

    getValidationClass(validation) {
      if (validation.$model === null) {
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      } else {
        validation.$touch();
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      }
    },
    async next() {
      if (!this.isHistoric) {
        let res = await this.updateTRegister(this.ldata);

        if (res.status === 200) {
          this.$toasted.success("T-registro actualizado", {
            theme: "bubble",
            position: "top-right",
            duration: 1000,
            className: "short-message",
          });
          this.$emit("nextForm");
        } else if (res.status >= 400) {
          this.$toasted.show("Error", {
            theme: "bubble",
            position: "top-right",
            duration: 1000,
            className: "short-message",
          });
        }
      } else {
        this.$store
          .dispatch("updateTregistersHistoric", {
            id: this.$store.state.business.currentTRegister,
            fk: this.historicId,
            body: this.ldata,
          })
          .then((res) => {
            if (res.status == 200) {
              this.$toasted.success("T-registro Historico actualizado", {
                theme: "bubble",
                position: "top-right",
                duration: 1000,
                className: "short-message",
              });
            } else if (res.status >= 400) {
              this.$toasted.show("Error", {
                theme: "bubble",
                position: "top-right",
                duration: 1000,
                className: "short-message",
              });
            }
          });
      }
    },

    selectRegSalud(value) {
      if (this.ldata.healthRegime != "01" && this.ldata.eps)
        delete this.ldata.eps;
    },

    selectRegPen(value) {
      if (this.ldata.pensionSystem == "02" && this.ldata.cuspCode)
        delete this.ldata.cuspCode;
      if (this.ldata.pensionSystem == "02" && this.ldata.pensionSystemType)
        delete this.ldata.pensionSystemType;
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS

//vue-material
.md-field {
  width: 21rem;
  margin: 0 2rem 2rem 24px;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.s-social {
  background-color: white;
  padding: 1rem 1rem 3rem 1rem;
  margin: 0 auto;
  position: relative;
  @include mq($sm) {
    padding: 1rem 3rem 3rem 3rem;
  }
  @include mq($md) {
    width: 90%;
    border-radius: 6px;
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
  }
  &__sgte {
    position: absolute;
    bottom: 0rem;
    right: 6rem;
    height: 2rem;
    line-height: 2rem;
    width: 8rem;
    text-align: center;
    background-color: $b-orange;
    color: #fff;
    font-weight: 600;
    clip-path: polygon(91% 0%, 100% 50%, 91% 100%, 0% 100%, 9% 50%, 0% 0%);
    @include mq($lg) {
      cursor: pointer;
    }
  }
}
.field-radio {
  // margin: 0 2rem 1rem 24px;
  width: 18rem;
  padding-top: 16px;
  position: relative;
  &__label {
    position: absolute;
    top: 0;
    font-size: 12px;
    color: rgba($b-blue, 0.6);
  }
}
</style>
